"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvenAdvisorNumberOfBedrooms = exports.SignUpGoal = void 0;
var SignUpGoal;
(function (SignUpGoal) {
    SignUpGoal["HELOC"] = "HELOC";
    SignUpGoal["CREDIT_CARD"] = "CREDIT_CARD";
    SignUpGoal["LIEN_REPORT"] = "LIEN_REPORT";
    SignUpGoal["CREDIT_SCORE"] = "CREDIT_SCORE";
    SignUpGoal["FIND_SUBSCRIPTIONS"] = "FIND_SUBSCRIPTIONS";
    SignUpGoal["BUDGET_SPEND_TRACKING"] = "BUDGET_SPEND_TRACKING";
    SignUpGoal["OTHER"] = "OTHER";
})(SignUpGoal || (exports.SignUpGoal = SignUpGoal = {}));
var AvenAdvisorNumberOfBedrooms;
(function (AvenAdvisorNumberOfBedrooms) {
    AvenAdvisorNumberOfBedrooms["ONE"] = "1";
    AvenAdvisorNumberOfBedrooms["TWO"] = "2";
    AvenAdvisorNumberOfBedrooms["THREE"] = "3";
    AvenAdvisorNumberOfBedrooms["FOUR_PLUS"] = "4+";
})(AvenAdvisorNumberOfBedrooms || (exports.AvenAdvisorNumberOfBedrooms = AvenAdvisorNumberOfBedrooms = {}));
